import React from "react";
import { Redirect } from "react-router-dom";
import { isLogged, modalPaths } from "../../ScrollReader/helpers";

import FormContainer from "../../design/onboarding/FormContainer";
import ToggleSignInSignUp from "../../design/onboarding/ToggleSignInSignUp";

import SignUpForm from "./SignUpForm.js";
import SocialLogins from "../SocialLogins.js";
import RedirectWhen from "../../utils/RedirectWhen.js";
import Modal from "../../Modal.js";
import { LOGIN_MODAL_SIZE as modalSize } from "../LoginModal";

class SignUpModal extends React.Component {
  render() {
    const { location: { search }, blockModal, success } = this.props;
    const animate = search === "" ? "start" : "stay";
    const loginPath=`${modalPaths.signIn}?m`
    return (
      <RedirectWhen when={!blockModal && isLogged()} to="">
        <Modal {...modalSize} current={animate} transitionTo={loginPath} success={success}>
          <FormContainer title={I18n.t("components.signUpModal.title")}>
            <SignUpForm />
            <SocialLogins />
            <ToggleSignInSignUp
              text={I18n.t("components.signUpModal.account")}
              buttonText={I18n.t("components.signUpModal.signIn")}
              hashPath={loginPath}
            />
          </FormContainer>
        </Modal>
      </RedirectWhen>
    );
  }
}

export default SignUpModal;
